











import Vue from 'vue';

import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component
export default class Error extends Vue { // eslint-disable-next-line
  // WATCHS
  @Watch('$route', { immediate: true, deep: true }) // eslint-disable-next-line
  routeChanged(to: any): void {
    document.title = to.meta.title || 'Error';
  }

  message = '';

  mounted() {
    this.message = this.$route.params.message;
  }
}
